module.exports = __webpack_public_path__ + "web/img/greetings-img.a1e7ff94.gif";